import { Modal } from 'bootstrap';
import {loadAndShowModal} from "../_components/modal";
import {trans} from "../i18n/i18n";

/**
 * Displays a modal with a given message, title, and action.
 * @param {string} message - The message to display in the modal.
 * @param {Function} action - The action to perform when the modal is confirmed.
 * @param {string} [title="Confirm Action"] - The title to display in the modal (optional).
 * @param {Function} [cancelAction] - The action to perform when the modal is closed without confirmation (optional).
 */
export async function showModal(message, action, title = "Confirm Action", cancelAction) {

    await loadAndShowModal('confirmation', {
        onLoad: () => initializeConfirmationModal({
            title,
            message,
            action,
            cancelAction,
        }),
    });
}

function initializeConfirmationModal({ title, message, action, cancelAction }) {
    const modalElement = document.getElementById('vincarioModal');
    const confirmationModalTitle = document.getElementById('confirmationModalLabel');
    const confirmationModalBody = document.getElementById('confirmationModalBody');
    const confirmActionBtn = document.getElementById('confirmActionBtn');

    confirmationModalTitle.innerText = title || trans("button.Confirm Action");
    confirmationModalBody.innerHTML = message || trans("Are you sure you want to proceed?");

    let confirmed = false;

    const onConfirm = () => {
        confirmed = true;
        if (typeof action === 'function') action();
        const modalInstance = Modal.getInstance(modalElement);
        if (modalInstance) {
            modalInstance.hide();
        }
    };

    const cleanup = () => {
        confirmActionBtn.removeEventListener('click', onConfirm);
        modalElement.removeEventListener('hidden.bs.modal', onHidden);
    };

    const onHidden = () => {
        if (!confirmed && cancelAction) {
            cancelAction();
        }
        cleanup();
    };

    confirmActionBtn.addEventListener('click', onConfirm);
    modalElement.addEventListener('hidden.bs.modal', onHidden);
}
